import PdfRenderer from "@features/session/components/PdfRenderer";
import DialogWrapper from "@memorang/ui/src/components/DialogWrapper";
import { Dialog } from "react-native-paper";

const source = {
	uri: "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/jbjs-assets/pdfs/chapman.pdf",
	cache: true,
};

type Props = {
	pageNumber: number | null;
	visible: boolean;
	handleClose: () => void;
};

const CitationSourceDialog = ({ pageNumber, visible, handleClose }: Props) => {
	return (
		<DialogWrapper
			visible={visible}
			handleClose={handleClose}
			maxWidth="md"
			height="80%"
		>
			<Dialog.Title>Citation Source</Dialog.Title>
			<Dialog.Content
				style={{
					flex: 1,
					paddingHorizontal: 8,
					paddingBottom: 8,
				}}
			>
				{pageNumber && <PdfRenderer pageNumber={pageNumber} source={source} />}
			</Dialog.Content>
		</DialogWrapper>
	);
};

export default CitationSourceDialog;
